import React, { useCallback, useContext } from 'react';
import ScorecardsContext from '../../../../contexts/ScorecardsContext';
import moment from 'moment';

const useScorecardOptions = ({
  selectedScorecard,
  setSelectedScorecard,
  setTitle,
}: {
  selectedScorecard: Scorecards.Scorecard | undefined;
  setSelectedScorecard: React.Dispatch<
    React.SetStateAction<Scorecards.Scorecard | undefined>
  >;
  setTitle: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const { scorecards } = useContext(ScorecardsContext);

  const getScorecards = useCallback(() => {
    return scorecards
      .filter((s) => !s.isHidden)
      .sort(
        (a, b) =>
          new Date(b.createdOn).valueOf() - new Date(a.createdOn).valueOf(),
      )
      .map((s) => ({
        key: s.id,
        label: `${s.title}`,
        subLabel: `Created on: ${moment(s.createdOn).format('MMM DD, YY @ HH:mm')}`,
        isSelected: !!selectedScorecard && s.id === selectedScorecard.id,
        onSelected: () => {
          setSelectedScorecard(s);
          setTitle(s.title);
        },
      }));
  }, [scorecards, selectedScorecard, setSelectedScorecard, setTitle]);

  return getScorecards();
};

export default useScorecardOptions;
